export default __webpack_public_path__ + "static/media/drstile-website-4.3f129d09.webp";